import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './containers/App';
import './style.css';

const container = document.getElementById('page');

const root = createRoot(container);

root.render(<App />);
